import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent } from "vue"

const _hoisted_1 = { class: "mb-5" }
const _hoisted_2 = { class: "mt-3" }
const _hoisted_3 = { class: "custom-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ElStep = _resolveComponent("ElStep")
  const _component_ElSteps = _resolveComponent("ElSteps")
  const _component_Button = _resolveComponent("Button")
  const _component_WizardStepper = _resolveComponent("WizardStepper")

  return (_openBlock(), _createBlock(_component_WizardStepper, null, {
    default: _withCtx(() => [
      _createVNode("h1", _hoisted_1, _toDisplayString(_ctx.currentStepTitle), 1),
      _createVNode("div", _hoisted_2, [
        (_ctx.scene != null)
          ? (_openBlock(), _createBlock(_component_ElSteps, {
              key: 0,
              active: _ctx.activeStep,
              class: "w-50"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.steps, (step, index) => {
                  return (_openBlock(), _createBlock(_component_ElStep, { key: index }))
                }), 128))
              ]),
              _: 1
            }, 8, ["active"]))
          : _createCommentVNode("", true),
        (_ctx.scene)
          ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.activeStepComponent), {
              key: 1,
              scene: _ctx.scene,
              onNextEnabled: _ctx.nextEnabledEvent
            }, null, 8, ["scene", "onNextEnabled"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("footer", _hoisted_3, [
        _createVNode(_component_Button, {
          class: "p-button-text",
          onClick: _ctx.handleButtonBackAction,
          label: _ctx.$t('AppResource.Back')
        }, null, 8, ["onClick", "label"]),
        _createVNode(_component_Button, {
          class: "p-button-text ml-auto",
          onClick: _ctx.handleButtonSubmitAction,
          label: _ctx.buttonSubmitLabel,
          disabled: _ctx.nextDisabled
        }, null, 8, ["onClick", "label", "disabled"])
      ])
    ]),
    _: 1
  }))
}